export default __webpack_public_path__ + "static/FoundersGrotesk-Bold-4f540e2dd9045893779268d69db82c4c.ttf";